import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Delete from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Grid, IconButton } from "@material-ui/core";

import { deleteDummyCard } from "features/planner/planner.actions";

const getBackgroundColor = ({ card }) =>
  card ? card.get("backColor") : undefined;

const getForeColor = theme => ({ card }) =>
  card.get("backColor")
    ? theme.palette.getContrastText(card.get("backColor"))
    : "inherit";

class DummyCard extends PureComponent {
  deleteCard = () => {
    const { card, dispatchDeleteCard } = this.props;
    dispatchDeleteCard(card.get("id"));
  };

  render() {
    const { card, classes, displayDeleteBtn, initializeEditCard } = this.props;

    return (
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        className={classes.root}
        onDoubleClick={initializeEditCard}
      >
        <Grid item xs className={classes.cardName}>
          <Typography
            noWrap
            variant="caption"
            className={classes.dummyCardName}
          >
            {card.get("name")}
          </Typography>
        </Grid>
        {displayDeleteBtn && (
          <Grid item className={classes.deleteContainer}>
            <IconButton
              className={classes.deleteButton}
              title="Delete"
              onClick={this.deleteCard}
            >
              <Delete fontSize="small" className={classes.deleteButtonIcon} />
            </IconButton>
          </Grid>
        )}
      </Grid>
    );
  }
}

DummyCard.defaultProps = {
  displayDeleteBtn: true,
};

const styles = theme => ({
  root: {
    cursor: "pointer",
    position: "relative",
    background: getBackgroundColor,
    padding: `0 ${theme.spacing(1)}px`,
    "&:hover": {
      opacity: 0.9,
    },
    "&:hover $deleteContainer": {
      display: "initial",
    },
  },
  dummyCardName: {
    fontWeight: 500,
    color: getForeColor(theme),
  },
  cardName: {
    overflow: "hidden",
  },
  deleteButton: {
    padding: 1,
  },
  deleteContainer: {
    right: 0,
    display: "none",
    position: "absolute",
  },
  deleteButtonIcon: {
    color: getForeColor(theme),
  },
});

export default compose(
  connect(null, {
    dispatchDeleteCard: deleteDummyCard,
  }),
  withStyles(styles),
)(DummyCard);
